import { render, staticRenderFns } from "./platformSettlementFund.vue?vue&type=template&id=57db2fa9&scoped=true"
import script from "./platformSettlementFund.vue?vue&type=script&lang=js"
export * from "./platformSettlementFund.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFund.vue?vue&type=style&index=0&id=57db2fa9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db2fa9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57db2fa9')) {
      api.createRecord('57db2fa9', component.options)
    } else {
      api.reload('57db2fa9', component.options)
    }
    module.hot.accept("./platformSettlementFund.vue?vue&type=template&id=57db2fa9&scoped=true", function () {
      api.rerender('57db2fa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformSettlementFund/platformSettlementFund.vue"
export default component.exports